import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import DetailsModal from 'common/components/Modal/DetailsModal'
import { ISavedState } from 'features/RiskManagement/Assessments'
import StateDetails from './StateDetails'

export interface IQRACompareStatesButton {
  stateList: ISavedState[]
}

export interface IQRACompareStatesModal {
  closeModal: () => void
  isModalOpen: boolean
  stateList: ISavedState[]
}

export interface IQRACompareStatesActionBar {
  closeModal: () => void
  selectedStates: number[]
}

const QRACompareStatesButton = ({ stateList }: IQRACompareStatesButton) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  return (
    <div>
      <QRACompareStatesModal
        closeModal={() => setIsModalOpen(false)}
        isModalOpen={isModalOpen}
        stateList={stateList}
      />
    </div>
  )
}

const QRACompareStatesModal = ({
  closeModal,
  isModalOpen,
  stateList
}: IQRACompareStatesModal) => {
  const [selectedStates, setSelectedStates] = useState<number[]>([])

  return (
    <DetailsModal
      title='Compare Saved States'
      open={isModalOpen}
      close={closeModal}
      footer={
        <ActionBar closeModal={closeModal} selectedStates={selectedStates} />
      }
    >
      <div className='border-t'>
        <StateDetails
          stateList={stateList}
          setSelectedStates={setSelectedStates}
        />
      </div>
    </DetailsModal>
  )
}

const ActionBar = ({
  closeModal,
  selectedStates
}: IQRACompareStatesActionBar) => {
  const navigate = useNavigate()
  const { search } = useLocation()

  const compare = (): void => {
    // TODO: wire up to table selection, lift function into parent
    navigate(
      `/risk-management/assessments/compare/${selectedStates[0]}..${selectedStates[1]}${search}`
    )
  }

  return (
    <div
      className={[
        'flex justify-end',
        'p-3',
        'border-t-2 border-gray-200'
      ].join(' ')}
    >
      <div className='grid grid-cols-2 gap-2'>
        <button
          className='w-24 font-semibold uppercase text-gray-700'
          onClick={closeModal}
        >
          Cancel
        </button>
        <button
          className={[
            'p-2',
            'w-24',
            'rounded bg-lighthouseBlue',
            'text-white uppercase',
            'font-semibold',
            'disabled:opacity-50'
          ].join(' ')}
          onClick={compare}
          disabled={selectedStates.length !== 2}
        >
          Compare
        </button>
      </div>
    </div>
  )
}

export default QRACompareStatesButton
